import React from 'react'
import { clsx } from 'clsx'
import WrongAnswerReviewList from '@components/certification/WrongAnswerReviewList'
import { CERTIFICATION_MAX_POINTS, CERTIFICATION_PASS_POINTS } from '@lib/certificationConfig'

export default function ResultsSummary({
  correct,
  total,
  wrong,
  passed,
  pointsEarned,
  wrongCount,
  penaltyTotal,
  rawScore,
  maxPoints
}) {
  const max = maxPoints ?? CERTIFICATION_MAX_POINTS
  const policyPass = CERTIFICATION_PASS_POINTS
  const policyMax = CERTIFICATION_MAX_POINTS
  const policyPassPct = Math.round((policyPass / policyMax) * 100)
  const pctCorrect = Math.round((correct / total) * 100)
  return (
    <div className="space-y-8">
      <div
        className={clsx(
          'rounded-2xl border p-6 sm:p-8 text-center',
          passed
            ? 'border-primary-500/40 bg-primary-500/10'
            : 'border-neutral-600 bg-navy-900/50'
        )}
        role="status"
        aria-live="polite"
      >
        <p className="text-sm uppercase tracking-wider text-primary-400 font-semibold mb-2">Results</p>
        <p className="text-display-3 text-white mb-2">
          {rawScore} / {max}
        </p>
        <p className="text-body-large text-neutral-300 mb-2">Total score (weighted + penalties)</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-2xl mx-auto text-left text-sm mb-6">
          <div className="rounded-lg bg-white/5 border border-white/10 p-3">
            <p className="text-neutral-500 text-xs uppercase tracking-wide mb-1">Correct</p>
            <p className="text-white font-semibold">
              {correct} / {total}
            </p>
          </div>
          <div className="rounded-lg bg-white/5 border border-white/10 p-3">
            <p className="text-neutral-500 text-xs uppercase tracking-wide mb-1">Points from items</p>
            <p className="text-primary-400 font-semibold">+{pointsEarned}</p>
          </div>
          <div className="rounded-lg bg-white/5 border border-white/10 p-3">
            <p className="text-neutral-500 text-xs uppercase tracking-wide mb-1">Wrong ({wrongCount})</p>
            <p className="text-red-300 font-semibold">−{penaltyTotal}</p>
          </div>
          <div className="rounded-lg bg-white/5 border border-white/10 p-3">
            <p className="text-neutral-500 text-xs uppercase tracking-wide mb-1">Item accuracy</p>
            <p className="text-neutral-200 font-semibold">{pctCorrect}%</p>
          </div>
        </div>
        <p className="text-body text-neutral-400 max-w-xl mx-auto">
          Scoring: questions 1–20 worth <span className="text-white font-medium">2 points</span> each if correct;
          questions 21–40 worth <span className="text-white font-medium">3 points</span> each if correct. Each
          incorrect answer deducts <span className="text-white font-medium">1 point</span>. Pass mark:{' '}
          <span className="text-white font-semibold">
            {policyPass} / {policyMax}
          </span>{' '}
          ({policyPassPct}%).
          {passed ? ' You passed.' : ' You did not reach the pass mark this time.'}
        </p>
      </div>

      {wrong.length > 0 && (
        <div className="glass-effect-dark rounded-2xl border border-primary-500/15 p-6 sm:p-8">
          <h3 className="text-heading-1 text-white mb-2">Review ({wrong.length} incorrect)</h3>
          <p className="text-sm text-neutral-500 mb-6">Each item below cost 1 point in addition to missing its value points.</p>
          <WrongAnswerReviewList wrong={wrong} />
        </div>
      )}
    </div>
  )
}
